// Listen for the variant:change event
document.addEventListener('variant:change', function(event) {
  var variant = event.detail.variant;

  // Update the variant metafields container
  var metafieldsContainer = document.getElementById('variant-metafields');
  if (!metafieldsContainer) {
    console.error("Metafields container not found");
    return;
  }

  // Update the additional details container
  var additionalDetailsContainer = document.querySelector('.additional-variant-details');
  if (!additionalDetailsContainer) {
    console.error("Additional details container not found");
    return;
  }

  // Get variant JSON data
  var variantDataScript = document.getElementById(`variant-${variant.id}-json`);
  if (!variantDataScript) {
    console.error(`Variant data script not found for variant ID: ${variant.id}`);
    return;
  }

  try {
    var variantData = JSON.parse(variantDataScript.textContent);

    // Update metafields in the container
    var heightElement = metafieldsContainer.querySelector('#variant-height');
    var diameterElement = metafieldsContainer.querySelector('#variant-diameter');
    var weightElement = metafieldsContainer.querySelector('#variant-wight');
    var widthElement = metafieldsContainer.querySelector('#variant-width');
    var lengthElement = metafieldsContainer.querySelector('#variant-length');
    var layersElement = metafieldsContainer.querySelector('#variant-layers');
    var sheetsElement = metafieldsContainer.querySelector('#variant-sheets');
    var materialElement = metafieldsContainer.querySelector('#variant-material');
    var sizeContainer = metafieldsContainer.querySelector('#variant-size');
    var quantityElement = metafieldsContainer.querySelector('#variant-quantity');
    var fillingQuantityElement = metafieldsContainer.querySelector('#variant-volume');
    var foldingElement = metafieldsContainer.querySelector('#variant-folding');
    
    if (heightElement) {
      heightElement.textContent = variantData.height_mm ? variantData.height_mm.value + " " + variantData.height_mm.unit : '';
    }    
    if (diameterElement) {
      diameterElement.textContent = variantData.diameter_mm ? variantData.diameter_mm.value : '';
    }
    if (weightElement) {
      weightElement.textContent = variantData.wight_g ? variantData.wight_g.value + " " + variantData.wight_g.unit : '';
    }
    if (widthElement) {
      widthElement.textContent = variantData.width_mm ? variantData.width_mm.value + " " + variantData.width_mm.unit : '';
    }
    if (lengthElement) {
      lengthElement.textContent = variantData.length_mm ? variantData.length_mm.value + " " + variantData.length_mm.unit : '';
    }
    if (layersElement) {
      layersElement.textContent = variantData.layers || '';
    }
    if (sheetsElement) {
      sheetsElement.textContent = variantData.sheets || '';
    }
    if (materialElement) {
      materialElement.textContent = variantData.material || '';
    }
    if (sizeContainer) {
      sizeContainer.innerHTML = "";
      if (variantData.size) {
        variantData.size.forEach(function(dimension, index, array) {
          sizeContainer.innerHTML += dimension.value + " " + dimension.unit;
          if (index < array.length - 1) {
            sizeContainer.innerHTML += " x ";
          }
        });
      }
    }
    if (fillingQuantityElement) {  // Update for filling quantity volume
      fillingQuantityElement.textContent = variantData.filling_quantity_volume ? variantData.filling_quantity_volume.value + " " + variantData.filling_quantity_volume.unit : '';
    }

    if (quantityElement) quantityElement.textContent = quantityText;
    
    if (foldingElement) {  // Update for folding
      foldingElement.textContent = variantData.folding || '';
    }

    // Update additional details container
    var additionalHeightElement = additionalDetailsContainer.querySelector('#variant-height');
    var additionalDiameterElement = additionalDetailsContainer.querySelector('#variant-diameter');
    var additionalWeightElement = additionalDetailsContainer.querySelector('#variant-wight');
    var additionalWidthElement = additionalDetailsContainer.querySelector('#variant-width');
    var additionalLengthElement = additionalDetailsContainer.querySelector('#variant-length');
    var additionalLayersElement = additionalDetailsContainer.querySelector('#variant-layers');
    var additionalSheetsElement = additionalDetailsContainer.querySelector('#variant-sheets');
    var additionalMaterialElement = additionalDetailsContainer.querySelector('#variant-material');
    var additionalFillingQuantityElement = additionalDetailsContainer.querySelector('#variant-volume'); // New element
    var additionalFoldingElement = additionalDetailsContainer.querySelector('#variant-folding'); // New element
    var additionalQuantityElement = additionalDetailsContainer.querySelector('#variant-quantity'); // New element
    var coatingElement = additionalDetailsContainer.querySelector('#variant-coating');
    var sustainableElement = additionalDetailsContainer.querySelector('#variant-sustainable');
    var druckElement = additionalDetailsContainer.querySelector('#variant-druck');
    var formElement = additionalDetailsContainer.querySelector('#variant-form');
    var foilThicknessElement = additionalDetailsContainer.querySelector('#variant-foil-thickness');
    var materialThicknessElement = additionalDetailsContainer.querySelector('#variant-material-thickness');
    var colorElement = additionalDetailsContainer.querySelector('#variant-color');
    var additionalDivisionElement = additionalDetailsContainer.querySelector('#variant-division');

    if (coatingElement) {
      coatingElement.textContent = variantData.coating || '';
    }
    if (sustainableElement) {
      sustainableElement.textContent = variantData.sustainable || '';
    }
    if (additionalDivisionElement) {
      additionalDivisionElement.textContent = variantData.division || '';
    }
    if (druckElement) {
      druckElement.textContent = variantData.druck || '';
    }
    if (formElement) {
      formElement.textContent = variantData.form || '';
    }
    if (foilThicknessElement) {
      foilThicknessElement.textContent = variantData.foil_thickness || '';
    }
    if (materialThicknessElement) {
      materialThicknessElement.textContent = variantData.material_thickness || '';
    }
    if (colorElement) {
      colorElement.textContent = variantData.color || '';
    }

    if (additionalHeightElement) {
      additionalHeightElement.textContent = variantData.height_mm ? variantData.height_mm.value + " " + variantData.height_mm.unit : '';
    }
    if (additionalQuantityElement) {
      additionalQuantityElement.textContent = variantData.units_quantity
        ? ((parseFloat(variantData.units_quantity) % 1 === 0
            ? parseInt(variantData.units_quantity)
            : parseFloat(variantData.units_quantity).toFixed(2).replace('.', ',')) +
          ' ' + (variantData.units_single || ''))
        : '';
    }
    if (additionalDiameterElement) {
        additionalDiameterElement.textContent = variantData.diameter_mm?.value || '';
    }
    if (additionalWeightElement) {
      additionalWeightElement.textContent = variantData.wight_g ? variantData.wight_g.value + " " + variantData.wight_g.unit : '';
    }
    if (additionalWidthElement) {
      additionalWidthElement.textContent = variantData.width_mm ? variantData.width_mm.value + " " + variantData.width_mm.unit : '';
    }
    if (additionalLengthElement) {
      additionalLengthElement.textContent = variantData.length_mm ? variantData.length_mm.value + " " + variantData.length_mm.unit : '';
    }
    if (additionalLayersElement) {
      additionalLayersElement.textContent = variantData.layers || '';
    }
    if (additionalSheetsElement) {
      additionalSheetsElement.textContent = variantData.sheets || '';
    }
    if (additionalMaterialElement) {
      additionalMaterialElement.textContent = variantData.material || '';
    }
    if (additionalFillingQuantityElement) {  // Update for filling quantity volume
      additionalFillingQuantityElement.textContent = variantData.filling_quantity_volume ? variantData.filling_quantity_volume.value + " " + variantData.filling_quantity_volume.unit : '';
    }
    if (additionalFoldingElement) {  // Update for folding
      additionalFoldingElement.textContent = variantData.folding || '';
    }
  } catch (e) {
    console.error("Error parsing variant JSON:", e);
  }
});
